import breadcrumbs from "@/views/modules/WorkPackages/MenuList.vue";
import lang from "@/views/modules/WorkPackages/language/en";
import Editor from '@tinymce/tinymce-vue';
import DateFormat from "@/plugins/date_format.js";

export default {
    name: "edit-workpackages",
   
    components: {
        breadcrumbs,
        'editor': Editor,
    },
    data() {
        return {
            loading: true,
            deleteProductModal: false,
            dataList: {},
            lang:[],
            currentUrl:'',
            allFiles:[],
            showEdit:false,
            edit:true,
            close:false,
            processing:false,
        }
    },
    mounted() {
        this.getWorkPackage();
        this.lang = lang;
        this.currentUrl = window.location.origin;
       
    },
    methods: {
       
        getWorkPackage() {
            const self = this;
            self.loading = true;
             window.currentAction = 'detail';
                axios.get('api/modules/workpackages/' + self.$route.params.id).then(function (response) {
                self.dataList = response.data;
                self.loading = false;
                
            }).catch(function () {
                self.loading = false;
            });
        },
        deleteWorkPackage() {
            const self = this;
            axios.delete('api/modules/workpackages/' + self.$route.params.id).then(function () {
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data deleted successfully').toString(),
                    type: 'success'
                });
                self.$router.push('/modules/workpackages');
            }).catch(function () {
                self.loading = false;
                self.deleteProductModal = false;
            });
        },
        changeFile(e) {
            let filelist = e.target.files;
            this.allFiles = [];
            
            for(let i = 0; i < filelist.length; i++){
                let image = e.target.files[i];
                const MAX_FILE_NAME_LENGTH = 40;

            if (image.name.length > MAX_FILE_NAME_LENGTH) {
                alert(`File name cannot exceed ${MAX_FILE_NAME_LENGTH} characters.`);
                e.target.value = '';
                this.allFiles = [];
                return;
            }
                let fileArr = [];
                let file_type_arr = e.target.files[i].type.split("/");
                this.fileName = file_type_arr;
                this.showFileName = image.name;
                // Get the file size
                let fileSize = image.size; // in bytes

                let setSize = window.app.max_file_size;
                let definedSize = 2097152;
                if(setSize[1] == 'M')
                {
                    definedSize = ((parseInt(setSize.slice(0,-1)) * 1024) * 1024); ///let  bytes = megabytes * 1024 * 1024;
                }
                if(setSize[1] == 'G')
                {
                    definedSize = (((parseInt(setSize.slice(0,-1)) * 1024) * 1024) * 1024); ///let  bytes = megabytes * 1024 * 1024;
                }
                if(fileSize <= definedSize)
                {
                let reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                //  this.file_content = e.target.result;
                    this.fileUpload = true;
                    fileArr.push(e.target.result, this.fileUpload, file_type_arr[1], image.name);
                    this.allFiles.push(fileArr);
                    }; 
                }else{
                    this.file_error = "The file size exceeds the maximum limit. Allowed file max size is "+ setSize;
                }
            }     

        },
        UploadFile(){
            const self = this;
            self.processing = true;
            let count = 0;
            let workid = document.getElementById("work_id").value;
            for(let i = 0; i < 95; i++){
                self.loadProgress(i);
            }
            axios.post('api/modules/workpackages/uploadFile', {'workid':workid,'filelist': self.allFiles, headers: { 'Content-Type': 'multipart/form-data' }}).then(function(res){
                if(res.data.message !=''){
                    /* self.$router.push(`/modules/workpackages/${workid}/detail`); */
                    self.loadProgress(95);
                    self.loadProgress(96);
                    self.loadProgress(97);
                    self.loadProgress(98);
                    self.loadProgress(99);
                    count = self.loadProgress(100);
                    if(count == 100){
                        $("#upload_work").val("");
                        $(".progress-bar").animate({
                            width: "0%",
                        }, 0);
                   $("#uploadFileModal").modal("hide");
                   self.processing = false;
                    self.getWorkPackage();
                    }
                }
            }).catch(function () {
                self.loading = false;
            }); 
            
        },
        loadProgress(widthBar){
            
            $(".progress-bar").animate({
                width: widthBar+"%",
            }, 0);
            if(widthBar == 100){
                return widthBar;
            }
        },
        GetDisplayDate(date='')
        {
            
            if(date !=''){
                const date_format = new DateFormat("dd/MM/yyyy");
                return date_format.changeDateFormat(date); 
            }
             
        },
        editEnable(chk){
            const self = this;
            if(chk == 'edit'){
                self.showEdit = true;
                self.edit = false;
                self.close = true;
            }else{
                self.updateColumn();
            }
        },
        updateColumn(){
            const self = this;
            let work_name = document.getElementById("workpackage_name").value;
            let work_desc = document.getElementById("workpackage_description").value;
            let work_status = document.getElementById("status").value;
            let formData = {
                'work_id': self.$route.params.id,
                'workpackage_name':work_name,
                'workpackage_description':work_desc,
                'status':work_status,
            }
           axios.put('api/modules/workpackages/'+self.$route.params.id, formData).then(function(response){
            self.showEdit = false;
            self.edit = true;
            self.close = false;
            self.getWorkPackage();
           }).catch(error => {
                self.showEdit = true;
                self.edit = false;
                self.close = true;
              
                let allerror = document.getElementsByClassName('error');
                for(let i = 0; i < allerror.length; i++)
                {
                    allerror[i].innerHTML = '';
                }
                let err = localStorage.getItem('Errors');
                let err_msg = (JSON.parse(err));
                let err_msg2 = err_msg && err_msg.errors ? err_msg.errors : {};
                Object.keys(err_msg2 || {}).forEach((key) => {
                    let errorval = err_msg2[key];
                   
                    let error_el = document.getElementById(key+"_error");
                        error_el.innerHTML = errorval
                });
                localStorage.removeItem('Errors');;
           })

        },
        removeFile(fileTbl, doc_id){
            const self = this;
            const deleteRecord = {'table': fileTbl, 'delete_id':doc_id};
            axios.post('api/modules/workpackages/remove', deleteRecord).then(function(response){
                self.getWorkPackage();
            });
        },
        downloadPrivate(doc_id, tbl,filename) {
            const self = this;
            const token = localStorage.getItem('token');
            if (!token) {
                alert('Please login to download files');
                return;
            }
            
            axios.get(`api/modules/download/${doc_id}/${tbl}`, {
                responseType: 'blob',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((response) => {
                //console.log(response);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            }).catch((error) => {
                console.error('Download failed:', error);
                self.$refs.notifyMsg.showAlert('Error', 'Download failed. File may not exist or access denied.');
            });
        }
    }
}